import { BreadcrumbItem, Breadcrumbs } from '@vds/breadcrumbs';
import { Body, Micro, Title } from '@vds/typography';
import React from 'react'
import { Icon } from '@vds/icons';
import './EventDetailsHeader.scss'
import { ButtonIcon } from '@vds/button-icons';
import { formatEventTime, mapTopicsAndTags } from '../../../utility/utils';
import { Modal } from '@vds/modals';
import CourseDetailsModalContent from '../../CourseDetailsPage/CourseDetailsModalContent/CourseDetailsModalContent.jsx';
import { contentClick } from '../../../common/Analytics/GAWrapper.jsx';

const EventDetailsHeader = ({ isInPersonEvent,currentInPersonEvent,formattedVideoLength, isRecorded, currentEvent, eventCxAemData, headerIcons, topicEnEsMaping, hasVideo }) => {
  let lng = localStorage.getItem("lng") ?? 'en';
  let userLanguageTitle = currentEvent?.localizeData?.filter(e => e.locale.indexOf(lng) != -1);
  let resourceTitle = isInPersonEvent ? currentInPersonEvent?.title : currentEvent?.title;
  if (userLanguageTitle.length > 0) {
    resourceTitle = userLanguageTitle[0].name;
  }
  let userTimeZone = Intl.DateTimeFormat().resolvedOptions()?.timeZone;
  const timeZone = isInPersonEvent ? currentEvent?.modules?.[0]?.inPersonLocation?.timeZone?.zone : userTimeZone;

  let dateTimeFormat = formatEventTime(
    isInPersonEvent ? currentInPersonEvent : currentEvent,timeZone,
    isInPersonEvent // Pass the flag to indicate if it's an in-person event
  );
  const navLabels = {};

  const isfromLP = localStorage?.getItem("categoryPath")?.includes("/learningpath");
  const lpIdUrl = isfromLP ? (eventCxAemData?.breadcrumb?.find((item) => { return item?.key === "learningDetailUrl" })?.url ?? "") + JSON.parse(localStorage?.getItem("learningPathObj"))?.lpId : "";
  const lpTitle = isfromLP ? JSON.parse(localStorage?.getItem("learningPathObj"))?.lpTitle : "";
  navLabels.homeLabel = eventCxAemData?.breadcrumb?.find((item) => { return item?.key === "Home" })?.label;
  navLabels.homeUrl = eventCxAemData?.breadcrumb?.find((item) => { return item?.key === "Home" })?.url;
  navLabels.courseLabel = isfromLP ? eventCxAemData?.breadcrumb?.find((item) => item?.key === "learningpath")?.label : eventCxAemData?.breadcrumb?.find((item) => item?.key === "Inpersonevents")?.label || eventCxAemData?.breadcrumb?.find((item) => item?.key === "Events")?.label;
  navLabels.courseUrl = isfromLP ? eventCxAemData?.breadcrumb?.find((item) => item?.key === "learningpath")?.url : eventCxAemData?.breadcrumb?.find((item) => item?.key === "Inpersonevents")?.url ||eventCxAemData?.breadcrumb?.find((item) => item?.key === "Events")?.url;
  // const [isInPersonEvent, setIsInPersonEvent] = React.useState(true);

  return (
    <div className='Event_Details_Header'>
      <div className='pv-8X sm-pv-6X'>
        {isfromLP ? (<Breadcrumbs
          surface="light">
          <BreadcrumbItem href={navLabels.homeUrl}>
            {navLabels.homeLabel}
          </BreadcrumbItem>
          <BreadcrumbItem href={navLabels.courseUrl}>
            {navLabels.courseLabel}
          </BreadcrumbItem>
          <BreadcrumbItem href={lpIdUrl} selected={true}>
            {lpTitle}
          </BreadcrumbItem>
          <BreadcrumbItem></BreadcrumbItem>
        </Breadcrumbs>) : (
          <Breadcrumbs
            surface="light">
            <BreadcrumbItem href={navLabels.homeUrl}>
              {navLabels.homeLabel}
            </BreadcrumbItem>
            <BreadcrumbItem href={navLabels.courseUrl} selected={true}>
              {navLabels.courseLabel}
            </BreadcrumbItem>
            <BreadcrumbItem>
              {/* {lpTitle} */}
            </BreadcrumbItem>
          </Breadcrumbs>
        )}
      </div>
      <div className='flex-apart'>
        <div className='pt-4X sm-pt-0X'>
          <Title size="2XLarge" bold>{resourceTitle}</Title>
        </div>
        <div className='pt-4X ml-12X sm-hide'>
          <Modal
            toggleButton={
              <ButtonIcon
                kind="lowContrast"
                size="small"
                onClick={() => {
                  let gaTopics = mapTopicsAndTags(currentEvent,eventCxAemData)
                  contentClick(resourceTitle, window.location.href, gaTopics, 'events_social_modal');
                }}
                renderIcon={(props) =>
                  <Icon name={eventCxAemData?.shareicon} size="small"></Icon>}
              />}
            surface="light"
            fullScreenDialog={false}
            disableAnimation={false}
            disableOutsideClick={false}
            ariaLabel="Testing Modal"
          >
            <CourseDetailsModalContent title={resourceTitle} shareAEMData={eventCxAemData?.shareModelDetails} currentEvent={currentEvent}/>
          </Modal>
        </div>
      </div>
      <div className='n-displayFlex n-justifyContentSpaceBetween' style={{alignItems: 'flex-start'}}>
        {!isRecorded && <div className='pt-6X n-displayFlex sm-n-flexDirectionCol'>
          <div className='n-displayFlex n-alignItemsCenter'>
            <Icon name="calendar" size="small" />
            <div className='ml-2X'>
              <Body size="large" bold>{dateTimeFormat}</Body>
            </div>
          </div>
          {isInPersonEvent && <div className='ml-6X sm-ml-0X sm-mt-1X n-displayFlex n-alignItemsCenter'>
            <Icon name="location" size="small" />
            <div className='ml-2X'>
              <Body size="large" bold>{[currentInPersonEvent?.modules?.[0]?.inPersonLocation?.city, currentInPersonEvent?.modules?.[0]?.inPersonLocation?.state].filter(Boolean) .join(', ')}</Body>
            </div>
          </div>}
        </div>}
        <div className='pt-6X sm-show hide'>
          <Modal
            toggleButton={
              <ButtonIcon
                kind="lowContrast"
                size="small"
                onClick={() => {
                  let gaTopics = mapTopicsAndTags(currentEvent,eventCxAemData)
                  contentClick(resourceTitle, window.location.href, gaTopics, 'events_social_modal');
                }}
                renderIcon={(props) =>
                  <Icon name={eventCxAemData?.shareicon} size="small"></Icon>}
              />}
            surface="light"
            fullScreenDialog={false}
            disableAnimation={false}
            disableOutsideClick={false}
            ariaLabel="Testing Modal"
          >
            <CourseDetailsModalContent title={resourceTitle} shareAEMData={eventCxAemData?.shareModelDetails} currentEvent={currentInPersonEvent}/>
          </Modal>
        </div>
      </div>
      {headerIcons && <div className='mt-8X Instructor_Icon_Container'>
        {headerIcons?.map(icon => {
          if (isRecorded && icon?.id == 2 && hasVideo) {
            return (icon && <>
            <div key={icon?.id} className='Instructor_Icon'>
              <div>
                {icon?.id == 1 ? <img src={icon?.name} alt={icon?.text} className={'skill-level-icon'} /> : <Icon name={icon?.name} size='large' />}
              </div>
              <div>
                <Micro>{icon?.text}</Micro>
              </div>
            </div>
              <div key={eventCxAemData?.bannericons?.[1]?.key} className='Instructor_Icon'>
                <div>
                  <Icon name={eventCxAemData?.bannericons?.[1]?.icon} size='large' />
                </div>
                <div>
                  <Micro>{eventCxAemData?.bannericons?.[1]?.iconlabel}{formattedVideoLength}</Micro>
                </div>
              </div>
            </>)
          } else {
            return (icon && <div key={icon?.id} className='Instructor_Icon'>
              <div>
                {icon?.id == 1 ? <img src={icon?.name} alt={icon?.text} className={'skill-level-icon'} /> : <Icon name={icon?.name} size='large' />}
              </div>
              <div>
                <Micro>{icon?.text}</Micro>
              </div>
            </div>)
          }
        }
        )}
      </div>}
    </div>
  )
}

export default EventDetailsHeader